export class AuthMethodAlreadyLinkedError extends Error {
    public readonly name: string;
    public readonly stack: string;

    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, AuthMethodAlreadyLinkedError.prototype);
    }
}
